import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminGet, adminPut } from "@/lib/adminApi";

const FIELDS = [
  { key: "gate_title", label: "Page d'entrée — titre" },
  { key: "gate_subtitle", label: "Page d'entrée — sous-titre" },
  { key: "welcome_title", label: "Première visite — titre" },
  { key: "home_hero", label: "Accueil — grande question" },
  { key: "home_sub", label: "Accueil — phrase d'accompagnement" },
];

export default function Cms() {
  const [texts, setTexts] = useState(null);

  useEffect(() => {
    adminGet("/cms").then((d) => setTexts(d.texts)).catch(() => {});
  }, []);

  if (!texts) return null;

  const save = async () => {
    try {
      await adminPut("/cms", { texts });
      toast("Textes du site enregistrés.");
    } catch {
      toast("Une erreur est survenue.");
    }
  };

  return (
    <div data-testid="admin-cms-module">
      <h2 className="rav-admin-h2">CMS — textes du site</h2>
      <p className="rav-page-sub rav-admin-note">Modifiez les grands textes visibles par les visiteuses, sans toucher au code.</p>
      <div className="rav-admin-form">
        {FIELDS.map((f) => (
          <label key={f.key} className="rav-field">
            <span>{f.label}</span>
            <input
              className="rav-input"
              data-testid={`cms-${f.key}`}
              value={texts[f.key] || ""}
              onChange={(e) => setTexts({ ...texts, [f.key]: e.target.value })}
            />
          </label>
        ))}
        <div className="rav-session-actions">
          <button type="button" className="rav-secondary-button rav-session-btn" data-testid="cms-save" onClick={save}>
            Enregistrer les textes
          </button>
        </div>
      </div>
    </div>
  );
}
